import { Badge } from "@mantine/core";

const getColor = (status: string) => {
	switch (status) {
		case "todo":
			return "yellow";
		case "in-progress":
			return "blue";
		case "nurse-review":
			return "purple";
		case "assignee-review":
			return "purple";
		case "client-review":
			return "orange";
		case "caregiver-review":
			return "pink";
		case "completed":
			return "green";
		case "pending-payroll":
			return "teal";
		default:
			return "gray";
	}
};

const getLabel = (status: string) => {
	switch (status) {
		case "todo":
			return "Todo";
		case "in-progress":
			return "In Progress";
		case "nurse-review":
			return "Nurse Review";
		case "assignee-review":
			return "Assignee Review";
		case "client-review":
			return "Client Review";
		case "caregiver-review":
			return "Caregiver Review";
		case "completed":
			return "Completed";
		case "pending-payroll":
			return "Pending Payroll";
		default:
			return status;
	}
};
export function CareFormStatusBadge({
	status,
	leftSide,
}: {
	status: string;
	leftSide?: React.ReactNode;
}) {
	return (
		<Badge color={getColor(status) as any} leftSection={leftSide}>
			{getLabel(status)}
		</Badge>
	);
}
